import axios from "axios";
import { handleActions } from "redux-actions";

import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

export const FETCH_PROJECT_STATUS_DASHBOARD_REQUEST = "FETCH_PROJECT_STATUS_DASHBOARD_REQUEST";
export const FETCH_PROJECT_STATUS_DASHBOARD = "FETCH_PROJECT_STATUS_DASHBOARD";
export const FETCH_PROJECT_STATUS_DASHBOARD_FAILED = "FETCH_PROJECT_STATUS_DASHBOARD_FAILED";

export const fetchProjectStatusDashboard: ThunkActionCreator =
  (projectId: number | string) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_PROJECT_STATUS_DASHBOARD_REQUEST });

    return axios
      .get(`${Config.API_SERVICE_URL}/api/dashboards/project-status/${projectId}`, getHeaders())
      .then((response) => {
        dispatch({
          type: FETCH_PROJECT_STATUS_DASHBOARD,
          payload: response.data,
        });
      })
      .catch((error: Error) => dispatch({ type: FETCH_PROJECT_STATUS_DASHBOARD_FAILED }));
  };

export interface ProjectDashboardData {
  data?: number[];
  labels?: string[];
  total?: number;
  colors?: string[];
}

export interface ProjectDashboardState {
  error: boolean;
  loading: boolean;
  content: ProjectDashboardData;
}

const initialState = {
  error: false,
  loading: false,
  content: {},
};

// Actions
const actions = {
  [FETCH_PROJECT_STATUS_DASHBOARD_REQUEST]: (state: ProjectDashboardState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_PROJECT_STATUS_DASHBOARD]: (state: ProjectDashboardState, action: AnyAction) => ({
    ...state,
    loading: false,
    content: action.payload,
  }),
  [FETCH_PROJECT_STATUS_DASHBOARD_FAILED]: (state: ProjectDashboardState) => ({
    ...state,
    loading: false,
    error: true,
    content: {},
  }),
};

export default handleActions<ProjectDashboardState, AnyAction>(actions, initialState);
